import './cv.css'
import Swal from 'sweetalert2'

const CvDownload = () => {
   // const cv = {
  //      url : '/assets/img-project/PROJET 2.jpg'
   // }
    //if someone clic on Download, here's a message 
    const HandleDownload = () => {
         Swal.fire({
      title: 'Download failed',
      text: 'Sorry, This item is not yet available, but you can take an appointment and contact us !',
      icon: 'error',
      confirmButtonText: 'close'
    });
    }
    return (
        <div className='cv'>
           <p>
             <h3> My Curriculum Vitae  </h3>
             <span> If you want to get more Informations about me, here's my curriculum vitae, you can know all about me until now.  </span>
        <a  href={HandleDownload}   onClick={HandleDownload}> Download</a>
           </p>
        </div>
    )
}

export default CvDownload;